import { render, staticRenderFns } from "./CheckPaymentStatus.vue?vue&type=template&id=768a2e1d&"
import script from "./CheckPaymentStatus.vue?vue&type=script&lang=js&"
export * from "./CheckPaymentStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports